// src/contexts/SubscriptionContext.jsx
import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';
import * as subscriptionsApi from '@api/subscriptions';

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const { token } = useAuth();
  const [accessMap, setAccessMap] = useState({});

  const checkAccess = async (route, tier) => {
    if (!token) return false;
    const key = `${route}-${tier}`;
    if (accessMap[key] !== undefined) return accessMap[key];

    try {
      const data = await subscriptionsApi.checkSubscriptionStatus(route, tier, token);
      const access = data.access || false;
      setAccessMap(prev => ({ ...prev, [key]: access }));
      return access;
    } catch {
      return false;
    }
  };

  return (
    <SubscriptionContext.Provider value={{ checkAccess }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);